import * as React from "react";
import { ICouncil } from 'src/interfaces';

interface IProps {
    councils: ICouncil[];
}
export const DottedLines = (props: IProps) => {
    const paths: JSX.Element[] = [];
    paths.push(<path id="path1464" d="M 38.893753,296.73542 157.42708,270.80625" fill="none"
    stroke="#fff" strokeWidth="0.4" strokeDasharray="2.4,2.4" />);  
    paths.push(<path id="path1520" d="M 158.48541,270.80625 119.0625,296.73542" fill="none"
    stroke="#ffffe7" strokeWidth="0.4" strokeDasharray="2.4,2.4" />);
    paths.push(<path id="path1468" d="m 159.01458,270.80625 39.42292,25.92917" fill="none"
    stroke="#fff" strokeWidth="0.4" strokeDasharray="2.4,2.4" />);
    paths.push(<path id="path1470" d="m 160.07292,270.80625 118.53334,25.92917" fill="none"
    stroke="#fff" strokeWidth="0.4" strokeDasharray="2.4,2.4" />);
    return(
        <svg xmlns="http://www.w3.org/2000/svg" id="svg8" viewBox="0 0 317.5 26.458333"
height="100" width="1200">
    <g transform="translate(0 -270.542)" id="layer1">
        <text id="text1374" y="276.688" x="62.007" style={{ lineHeight: 1.25 }}
        fontWeight="400" fontSize="10.583" fontFamily="sans-serif" letterSpacing="0"
        wordSpacing="0" strokeWidth="0.265" />
        {props.councils.map(
            (_, index) => (
                paths[index]
            )
        )}
    </g>
</svg>
    )
}


// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/CouncilService/DottedLines.tsx